import { Component, type ErrorInfo, type ReactNode } from "react";

import { Card, CardBody } from "@/components/ui/Card";

interface Props {
  name: string;
  children: ReactNode;
}

/** Keeps one widget's render error from blanking the whole dashboard: that
 * widget shows a small notice, every other widget carries on. */
export class WidgetBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`Dashboard widget "${this.props.name}" failed to render:`, error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Card className="h-full">
        <CardBody className="flex h-full flex-col justify-center gap-2">
          <p className="text-sm font-medium text-slate-700">{this.props.name}</p>
          <p className="text-sm text-slate-500">This widget couldn&apos;t be displayed.</p>
          <button type="button" onClick={() => this.setState({ failed: false })} className="self-start text-xs font-medium text-primary-700 underline hover:no-underline">
            Try again
          </button>
        </CardBody>
      </Card>
    );
  }
}
